import type { ReactNode } from "react";

interface PageHeroProps {
  icon: ReactNode;
  title: ReactNode;
  subtitle: string;
  children?: ReactNode;
}

/**
 * Shared hero used by mode pages (Workflows, Analyse, Draft, Team).
 * Matches the `.diag-hero` pattern from the static HTML prototypes.
 */
export function PageHero({ icon, title, subtitle, children }: PageHeroProps) {
  return (
    <section className="diag-hero">
      <div className="diag-hero-icon" aria-hidden="true">
        {icon}
      </div>
      <h1>{title}</h1>
      <p className="diag-hero-sub">{subtitle}</p>
      {children}
    </section>
  );
}
